module.exports = __webpack_public_path__ + "static/media/houseWithScheme.9d96e8e0.svg";